/*
  PaginationBar.jsx — Reusable pagination footer used across list views.
  Extracted from CollectionPlanningPage.jsx (Feb 2026 refactor).
*/
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export default function PaginationBar({ total, page, pageSize, onPageChange, onPageSizeChange, testId = "pagination" }) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const go = (n) => onPageChange(Math.max(1, Math.min(pageCount, n)));
  return (
    <div className="flex items-center justify-between flex-wrap gap-2 px-4 py-2.5 border-t border-slate-100 bg-slate-50/60 text-[11px] text-slate-600" data-testid={testId}>
      <div className="flex items-center gap-2">
        <span>Rows per page</span>
        <select value={pageSize} onChange={(e) => { onPageSizeChange(Number(e.target.value)); onPageChange(1); }} className="h-7 border border-slate-200 rounded px-1.5 text-[11px] bg-white">
          {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span className="text-slate-400">·</span>
        <span>Showing <strong className="text-slate-800">{from}-{to}</strong> of <strong className="text-slate-800">{total}</strong></span>
      </div>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => go(1)} disabled={page === 1} data-testid={`${testId}-first`}><ChevronsLeft className="w-3.5 h-3.5" /></Button>
        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => go(page - 1)} disabled={page === 1} data-testid={`${testId}-prev`}><ChevronLeft className="w-3.5 h-3.5" /></Button>
        <span className="px-2 font-medium text-slate-700 min-w-[60px] text-center">{page} / {pageCount}</span>
        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => go(page + 1)} disabled={page >= pageCount} data-testid={`${testId}-next`}><ChevronRight className="w-3.5 h-3.5" /></Button>
        <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={() => go(pageCount)} disabled={page >= pageCount} data-testid={`${testId}-last`}><ChevronsRight className="w-3.5 h-3.5" /></Button>
      </div>
    </div>
  );
}
